export default __webpack_public_path__ + "static/ProximaNova-ThinItalic-0d623d616d5d3cbd48024eb053f53476.otf";